module.exports = __webpack_public_path__ + "img/web2_3.f9210aaa.jpg";